// This file can be used to store static context or load it from a file if needed.
// However, the primary context is now fetched dynamically from the backend.

// You can paste your text file content here if you want to use it as a fallback or additional context.
export const additionalContext = `
Add your custom text file content here...
`;

export const dietPlan = `
# Diet Plan

## Breakfast (8:00 AM)
- Oatmeal (1 cup cooked) with berries and almond butter
- 2 Boiled Eggs
- Green Tea

## Lunch (1:00 PM)
- Grilled Chicken Breast (150g)
- Quinoa (1 cup cooked)
- Steamed Broccoli and Carrots
- Olive Oil dressing

## Snack (4:00 PM)
- Greek Yogurt (1 cup)
- Apple
- Handful of Almonds

## Dinner (7:00 PM)
- Baked Salmon (150g)
- Sweet Potato (medium)
- Asparagus
- Mixed Green Salad

## Hydration
- Drink at least 3 liters of water daily.
`;

export const workoutPlan = `
# Workout Plan

## Monday: Chest & Triceps
- Bench Press: 3 sets x 10 reps
- Incline Dumbbell Press: 3 sets x 12 reps
- Cable Flyes: 3 sets x 15 reps
- Tricep Pushdowns: 3 sets x 12 reps
- Overhead Dumbbell Extension: 3 sets x 12 reps

## Tuesday: Back & Biceps
- Pull-ups: 3 sets x failure
- Barbell Rows: 3 sets x 10 reps
- Lat Pulldowns: 3 sets x 12 reps
- Barbell Curls: 3 sets x 10 reps
- Hammer Curls: 3 sets x 12 reps

## Wednesday: Rest / Active Recovery (Yoga/Walking)

## Thursday: Legs & Shoulders
- Squats: 3 sets x 10 reps
- Leg Press: 3 sets x 12 reps
- Lunges: 3 sets x 12 reps (each leg)
- Overhead Press: 3 sets x 10 reps
- Lateral Raises: 3 sets x 15 reps

## Friday: Full Body Circuit
- Burpees: 3 sets x 15 reps
- Kettlebell Swings: 3 sets x 20 reps
- Box Jumps: 3 sets x 15 reps
- Plank: 3 sets x 60 seconds

## Saturday: Cardio (Running/Cycling) - 45 mins

## Sunday: Rest
`;
